export const capitalizar = (str) => {
  if (!str) return ''

  return str
    .toLowerCase()
    .split(' ')
    .map((palabra) => (palabra ? palabra.charAt(0).toUpperCase() + palabra.slice(1) : palabra))
    .join(' ')
}

export const acortarTexto = (str, length = 50) => {
  if (!str) return ''
  return str.length > length ? `${str.slice(0, length).trim()}...` : str
}

export const validarTexto = (valor) => String(valor ?? '').trim() !== ''
